import { createApp } from "vue";
import App from "./App.vue";
// import "@/utils/rem";
import "vant/lib/index.css";
import { Button } from "vant";
// 引入路由
import router from "./router";
import "./assets/baseCss.css";
let app = createApp(App);
app.use(router);
app.use(Button);
app.mount("#app");
